// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ClanCastleTroops_wrapper__sU6Lb","item":"ClanCastleTroops_item__ZKA51","image":"ClanCastleTroops_image__xAQmS","count":"ClanCastleTroops_count__8XmFv"};